import { Component } from '@angular/core';

@Component({
    selector: 'cl-center-content',
    templateUrl: './center-content.component.html'
})
export class CenterContentComponent {
    static $name: string = 'clCenterContent';

    constructor(
    ) {
    }
}
